import { Icon24DescribeVideoLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const VideoDescriberIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M16.0203 11.3H22.0203"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0203 14.3H22.0203"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 17.1819L22 17.1819"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.77026 20.3H22.0203"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8 9.69995L8 6.69995V12.7L12.8 9.69995Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 17.2H3.86364H1.81818C1.36631 17.2 1 16.7203 1 16.1285V3.27138C1 2.67965 1.36631 2.19995 1.81818 2.19995H18.1818C18.6337 2.19995 19 2.67965 19 3.27138V6.48567V8.5"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VideoDescriberIcon = fplIcon(VideoDescriberIconLocal, Icon24DescribeVideoLarge);
